// src/pages/BoardsPage.js
import React, { useState } from "react";
import BoardList from "../components/Board/BoardList";
import PostList from "../components/Board/PostList";
import PostSearchPanel from "../components/Board/PostSearchPanel";
import PostForm from "../components/Board/PostForm";
import { useAuth } from "../context/AuthContext"; // ✅ 추가

const BoardsPage = () => {
  const [selectedBoard, setSelectedBoard] = useState(null);
  const [search, setSearch] = useState("");
  const [tag, setTag] = useState("");
  const [showForm, setShowForm] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const { isLoggedIn } = useAuth(); // ✅ 로그인 여부 가져오기

  const handleCreated = () => setRefreshKey((prev) => prev + 1);

  return (
    <div className="flex gap-6 p-6 min-h-screen bg-gray-50">
      {/* 좌측: 게시판 목록 */}
      <aside className="w-1/5 min-w-[180px] bg-white rounded shadow p-4 h-fit">
        <BoardList
          selectedBoard={selectedBoard}
          onSelectBoard={(slug) => {
            setSelectedBoard(slug);
            setSearch("");
            setTag("");
            setShowForm(false);
          }}
        />
      </aside>

      {/* 중앙: 게시글 리스트 또는 작성 폼 */}
      <main className="flex-1 bg-white rounded shadow p-6">
        {selectedBoard && !showForm && isLoggedIn && ( // ✅ 로그인 조건 추가
          <div className="mb-4 text-right">
            <button
              className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600"
              onClick={() => setShowForm(true)}
            >
              ➕ 게시글 등록
            </button>
          </div>
        )}

        {showForm ? (
          <PostForm
            boardSlug={selectedBoard}
            onClose={() => setShowForm(false)}
            onCreated={handleCreated}
          />
        ) : (
          <PostList
            boardSlug={selectedBoard}
            search={search}
            tag={tag}
            key={refreshKey}
          />
        )}
      </main>

      {/* 우측: 검색 + 태그 필터 */}
      <aside className="w-1/4 min-w-[200px] bg-white rounded shadow p-4 h-fit">
        <PostSearchPanel
          boardSlug={selectedBoard}
          onSearch={setSearch}
          onTagSelect={setTag}
        />
      </aside>
    </div>
  );
};

export default BoardsPage;
